import { VariavelPadrao } from './variaveis_padroes';
import { Grupo } from './../grupos/grupo';

export class TipoCertificado{
  id: number;
  descricao: string;
  background: File;
  grupo_id: number;
  verso: boolean = false;
  ativo: boolean;
  variaveis_padroes: VariavelPadrao[];
  grupo: Grupo;
  constructor(){
    this.variaveis_padroes = [ ];
    this.grupo =  new Grupo;
  }
}



// WEBPACK FOOTER //
// ./src/app/tipos_certificados/tipo_certificado.ts